export default {
    topFix() {
        parent.scroll(0, 0);
    }
};